import { Settings } from '@/components/settings-page';
import { Helmet as Head } from 'react-helmet';
import useRefresh from '../../hooks/use-refresh';

const SettingPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Settings</title>
      </Head>
      <Settings />
    </>
  );
};

export default SettingPage;
